import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoin1"><Path d="M12.5 2.5H11C6.30558 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.30558 21.5 11 21.5H12.5M21.5 12C21.5 17.2467 17.6944 21.5 13 21.5C8.30558 21.5 4.5 17.2467 4.5 12C4.5 6.75329 8.30558 2.5 13 2.5C17.6944 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCoin1;
